import { useQuery } from "@apollo/client";
import { STUDENT_QUERY } from "@/api/queries/student";
import { StudentQuery } from "@/__generated__/types";

export const useStudent = (
  id: string,
  organizationId: string,
  profilePhotoSize = 400,
) => {
  const { data, loading, error } = useQuery<StudentQuery>(STUDENT_QUERY, {
    variables: { id, organizationId, profilePhotoSize },
    skip: !id || !organizationId,
  });

  if (data?.node?.__typename === "Student") {
    return {
      student: data?.node,
      loading,
      error,
    };
  }

  return {
    student: undefined,
    loading,
    error,
  };
};
